export default __webpack_public_path__ + "static/media/3D.2219d9c8.svg";